(function () {
function $6390b11dbeadc9da$export$184ff5d81c0e5775(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $290eb4900206e948$export$20c20a422940e173(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2(receiver, privateMap) {
    var descriptor = (0, $290eb4900206e948$export$20c20a422940e173)(receiver, privateMap, "get");
    return (0, $6390b11dbeadc9da$export$184ff5d81c0e5775)(receiver, descriptor);
}


function $a5742523b6df67b4$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $536e2c71784255ec$export$e235798705076415(obj, privateMap, value) {
    (0, $a5742523b6df67b4$export$6b10452b5ac97eba)(obj, privateMap);
    privateMap.set(obj, value);
}


function $62deade4fc47f207$export$b7b24cdba6bcb11c(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $86870fdf2eb51a70$export$268446c9779b3a21(receiver, privateMap, value) {
    var descriptor = (0, $290eb4900206e948$export$20c20a422940e173)(receiver, privateMap, "set");
    (0, $62deade4fc47f207$export$b7b24cdba6bcb11c)(receiver, descriptor, value);
    return value;
}


function $4cc40f715897f8ef$export$2abff382f801d1eb(receiver, descriptor) {
    if (descriptor.set) {
        if (!descriptor.get) throw new TypeError("attempted to read set only private field");
        if (!("__destrWrapper" in descriptor)) descriptor.__destrWrapper = {
            set value (v){
                descriptor.set.call(receiver, v);
            },
            get value () {
                return descriptor.get.call(receiver);
            }
        };
        return descriptor.__destrWrapper;
    } else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        return descriptor;
    }
}



function $3a63a2ea56dfd751$export$34564f03cc238d9f(receiver, privateMap) {
    var descriptor = (0, $290eb4900206e948$export$20c20a422940e173)(receiver, privateMap, "update");
    return (0, $4cc40f715897f8ef$export$2abff382f801d1eb)(receiver, descriptor);
}


function $423958fa057c9ccd$export$ccedaf978f62b9dd(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}



function $86ed3387c72e1975$export$1002c20f28174dbf(obj, privateSet) {
    (0, $a5742523b6df67b4$export$6b10452b5ac97eba)(obj, privateSet);
    privateSet.add(obj);
}



function $259d7bf9454f91de$export$9e7656e55e2ea4f7(receiver, classConstructor) {
    if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
}


function $55f9dfaf0db52376$export$d8c518df5e371131(descriptor, action) {
    if (descriptor === undefined) throw new TypeError("attempted to " + action + " private static field before its declaration");
}


function $7dddac0e5986aad9$export$5160b3efe6f07044(receiver, classConstructor, descriptor) {
    (0, $259d7bf9454f91de$export$9e7656e55e2ea4f7)(receiver, classConstructor);
    (0, $55f9dfaf0db52376$export$d8c518df5e371131)(descriptor, "get");
    return (0, $6390b11dbeadc9da$export$184ff5d81c0e5775)(receiver, descriptor);
}



function $685ea8009867723a$export$68238ee8e0a3fa8c(receiver, classConstructor, method) {
    (0, $259d7bf9454f91de$export$9e7656e55e2ea4f7)(receiver, classConstructor);
    return method;
}


const $3c5a058a16dfb7f1$export$4c10b1e0a3c7fbb7 = [
    {
        "name": "modal",
        "html": '<dialog class="dialog" id="modal-tutocitron" aria-label="modale" data-modal-type="default">\n    <form method="dialog" class="dialog-container dialog-small">\n    \n    <header class="dialog-header"><h3 class="heading text-2xl text-fluid black">lang:modal_header_content</h3><button class="btn btn-link btn-icon btn-icon-only icon-after btn-black btn-medium rounded-none js-modal-close"><span class="sr-only">Fermer la modale</span><i class="icon icon-outlined-tuto-close text-xl" aria-hidden="true"></i></button></header><div class="dialog-main-content"> </div><footer class="dialog-footer"><menu class="dialog-footer-menu"><li class="dialog-footer-li"><button class="btn btn-primary btn-small rounded-full hidden hiddenSandbox" id="tarteaucitronAllDenied" type="button">lang:modal_button_cancel</button></li><li class="dialog-footer-li"><button class="btn btn-primary btn-small rounded-full hidden hiddenSandbox" id="tarteaucitronAllAllowed" type="button">lang:modal_button_confirm</button></li><li class="dialog-footer-li"><button class="btn btn-secondary btn-small rounded-full" id="cancel" type="reset">lang:modal_button_cancel</button></li><li class="dialog-footer-li"><button class="btn btn-primary btn-small rounded-full" id="confirm" type="submit" value="confirm">lang:modal_button_confirm</button></li></menu></footer></form></dialog>'
    },
    {
        "name": "floating-bar",
        "html": '<template id="floating-bar-template"><div class="floating-bar-wrapper"><div class="floating-bar"><div class="2xl:w-1/2 mb-0"><p class="floating-bar-text js-floating-bar-text">lang:alertBigPrivacy</p></div><div class="buttons-container"><button class="btn btn-primary btn-medium rounded-full cookies-accept-all">lang:acceptAll</button><button class="btn btn-tertiary btn-medium rounded-full cookies-reject-all">lang:denyAll</button><button class="btn btn-link btn-inline btn-medium rounded-none cookies-customize">lang:personalize</button></div></div></div></template>'
    }
];


const $e4d551bd4b153854$export$359be4c8544d6fb1 = {
    fr: {
        "alertBigPrivacy": "Bienvenue sur Tuto.com ! Nous utilisons des cookies pour am\xe9liorer votre exp\xe9rience, c'est ok pour vous ?",
        "acceptAll": "Tout accepter",
        "personalize": "Personnaliser",
        "allow": "Autoriser",
        "deny": "Interdire",
        "noCookie": "Ce service ne d\xe9pose aucun cookie.",
        "useCookie": "Ce service peut d\xe9poser",
        "useCookieCurrent": "Ce service a d\xe9pos\xe9",
        "useNoCookie": "Ce service n'a d\xe9pos\xe9 aucun cookie.",
        "more": "En savoir plus",
        "source": "Voir le site officiel",
        "credit": "Gestion des cookies par tarteaucitron.js",
        "noServices": "Ce site n'utilise aucun cookie n\xe9cessitant votre consentement.",
        "allowAll": "Tout accepter",
        "denyAll": "Tout refuser",
        "mandatoryTitle": "Cookies obligatoires",
        "mandatoryText": "Ce site utilise des cookies n\xe9cessaires \xe0 son bon fonctionnement. Ils ne peuvent pas \xeatre d\xe9sactiv\xe9s.",
        // tuto addition
        "modal_header_content": "Chargement",
        "modal_button_confirm": "Confirmer",
        "modal_button_cancel": "Annuler",
        "modalAriaLabel": "dialog window",
        "modalCheckAll": "Tout cocher"
    },
    en: {
        // tuto addition
        "modal_header_content": "Loading",
        "modal_button_confirm": "Confirm",
        "modal_button_cancel": "Cancel",
        "modalAriaLabel": "dialog window",
        "modalCheckAll": "Check all"
    }
};


const $15d75720b00b40ae$var$ajax_prefixCitron = "/a_";
const $15d75720b00b40ae$var$getFromTemplateCitron = (TemplateIDCitron)=>{
    var _document_querySelector, _document_querySelector_content, _document_querySelector_content_firstElementChild;
    return (_document_querySelector = document.querySelector(`${TemplateIDCitron}`)) === null || _document_querySelector === void 0 ? void 0 : (_document_querySelector_content = _document_querySelector.content) === null || _document_querySelector_content === void 0 ? void 0 : (_document_querySelector_content_firstElementChild = _document_querySelector_content.firstElementChild) === null || _document_querySelector_content_firstElementChild === void 0 ? void 0 : _document_querySelector_content_firstElementChild.cloneNode(true);
};
let $15d75720b00b40ae$var$TutoCitronInst;
// tarteaucitron.userInterface.OpenPanel = function () {}
//
// tarteaucitron.userInterface.ClosePanel = function () {}
// Overload openAlert() from tarteaucitron to avoid auto set focus on element (scroll bottom gate)
tarteaucitron.userInterface.openAlert = function() {
    "use strict";
    var c = "tarteaucitron";
    tarteaucitron.userInterface.css(c + "Percentage", "display", "none");
    tarteaucitron.userInterface.css(c + "AlertSmall", "display", "none");
    tarteaucitron.userInterface.css(c + "Icon", "display", "none");
    tarteaucitron.userInterface.css(c + "AlertBig", "display", "block");
    tarteaucitron.userInterface.css(c + "AlertBig", "height", "0");
    tarteaucitron.userInterface.css(c + "AlertBig", "overflow", "hidden");
    tarteaucitron.userInterface.addClass(c + "Root", "tarteaucitronBeforeVisible");
    //ie compatibility
    var tacOpenAlertEvent;
    if (typeof Event === "function") tacOpenAlertEvent = new Event("tac.open_alert");
    else {
        tacOpenAlertEvent = document.createEvent("Event");
        tacOpenAlertEvent.initEvent("tac.open_alert", true, true);
    }
    //end ie compatibility
    window.dispatchEvent(tacOpenAlertEvent);
};
tarteaucitron.userInterface.jsSizing = function(type) {
    $15d75720b00b40ae$var$TutoCitronInst === null || $15d75720b00b40ae$var$TutoCitronInst === void 0 ? void 0 : $15d75720b00b40ae$var$TutoCitronInst.jsSizing(type);
};
tarteaucitron.userInterface.respondAll = function(status, type, allowSafeAnalytics) {
    "use strict";
    const tac_services = tarteaucitron.services;
    let tac_service, key, index = 0, _reloadThePage = false;
    for(index = 0; index < tarteaucitron.job.length; index += 1){
        if (typeof type !== "undefined" && type !== "" && tac_services[tarteaucitron.job[index]].type !== type) continue;
        if (allowSafeAnalytics && typeof tac_services[tarteaucitron.job[index]].safeanalytic !== "undefined" && tac_services[tarteaucitron.job[index]].safeanalytic === true) continue;
        tac_service = tac_services[tarteaucitron.job[index]];
        key = tac_service.key;
        if (tarteaucitron.state[key] !== status) {
            if (status === false && tarteaucitron.launch[key] === true) _reloadThePage = true;
            if (status === true && tarteaucitron.launch[key] !== true) {
                tarteaucitron.pro("!" + key + "=engage");
                tarteaucitron.launch[key] = true;
                if (typeof tarteaucitronMagic === "undefined" || tarteaucitronMagic.indexOf("_" + key + "_") < 0) tarteaucitron.services[key].js();
                tarteaucitron.sendEvent(key + "_loaded");
            }
            const itemStatusElem = document.getElementById("tacCurrentStatus" + key);
            if (status === true) itemStatusElem.innerHTML = tarteaucitron.lang.allowed;
            else itemStatusElem.innerHTML = tarteaucitron.lang.disallowed;
            tarteaucitron.state[key] = status;
            tarteaucitron.cookie.create(key, status);
            tarteaucitron.userInterface.color(key, status);
        }
    }
    $15d75720b00b40ae$var$pushConfirmation(_reloadThePage);
};
tarteaucitron.events.init = function() {
    tarteaucitronCustomText = (0, $e4d551bd4b153854$export$359be4c8544d6fb1)[tarteaucitron.getLanguage()] || (0, $e4d551bd4b153854$export$359be4c8544d6fb1)["en"];
    tarteaucitronForceLanguage = document.documentElement.getAttribute("lang") || "fr";
};
tarteaucitron.events.load = function() {
    $15d75720b00b40ae$var$TutoCitronInst = new $15d75720b00b40ae$var$TutoCitron();
};
var /**
     * @type {HTMLElement}
     */ $15d75720b00b40ae$var$_floatingElement = /*#__PURE__*/ new WeakMap(), /**
     * @type {HTMLElement}
     */ $15d75720b00b40ae$var$_btnAcceptAll = /*#__PURE__*/ new WeakMap(), /**
     * @type {HTMLElement}
     */ $15d75720b00b40ae$var$_btnDenyAll = /*#__PURE__*/ new WeakMap(), /**
     * @type {HTMLElement}
     */ $15d75720b00b40ae$var$_btnCustomize = /*#__PURE__*/ new WeakMap(), /**
     * @type {HTMLElement}
     */ $15d75720b00b40ae$var$_tutoModal = /*#__PURE__*/ new WeakMap(), /**
     * @type {HTMLElement}
     */ $15d75720b00b40ae$var$_tacRoot = /*#__PURE__*/ new WeakMap(), /**
     * @type {HTMLElement}
     */ $15d75720b00b40ae$var$_tacModal = /*#__PURE__*/ new WeakMap(), /**
     * main wrapper for check all input switch
     * @type {HTMLElement}
     */ $15d75720b00b40ae$var$_switchAll = /*#__PURE__*/ new WeakMap(), /**
     *
     * @type {string}
     */ $15d75720b00b40ae$var$_switchAllId = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_acceptAllCallback = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_denyAllCallback = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_customizeAllCallback = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_switchAllCallback = /*#__PURE__*/ new WeakMap(), /**
     *
     * @type {number}
     */ $15d75720b00b40ae$var$_checkedServicesCount = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_modalInstance = /*#__PURE__*/ new WeakMap(), /**
     * Build & return a <li> matching service formatting for check all feature
     * @return {HTMLElement}
     */ $15d75720b00b40ae$var$_buildCheckAllRow = /*#__PURE__*/ new WeakSet(), /**
     * Create modal content
     * @return {string}
     */ $15d75720b00b40ae$var$_buildModalContent = /*#__PURE__*/ new WeakSet(), /**
     *
     */ $15d75720b00b40ae$var$_initModal = /*#__PURE__*/ new WeakSet(), /**
     * Create tuto modal content from tac vanilla content
     */ $15d75720b00b40ae$var$_buildModal = /*#__PURE__*/ new WeakSet(), /**
     *
     * @param id
     * @param name
     * @param value
     * @param labelledby
     * @param isChecked
     * @param isDisabled
     * @return {HTMLElement}
     */ $15d75720b00b40ae$var$_createSwitchElement = /*#__PURE__*/ new WeakSet(), /**
     * Create & append a switch input beside button, hide button
     * @param _buttonElement
     */ $15d75720b00b40ae$var$_convertButtonToSwitch = /*#__PURE__*/ new WeakSet(), /**
     *
     * @param name
     * @return {string|*|string}, html source of named element in TutoCitronHtmlSource
     */ $15d75720b00b40ae$var$_getHtmlSourceElement = /*#__PURE__*/ new WeakSet(), /**
     * pick floating bar source in json and append it to root html
     */ $15d75720b00b40ae$var$_initFloatingBar = /*#__PURE__*/ new WeakSet(), /**
     * convert vanilla TAC bar to impulse floating bar
     */ $15d75720b00b40ae$var$_convertToFloatingBar = /*#__PURE__*/ new WeakSet(), /**
     * init click event on buttons
     */ $15d75720b00b40ae$var$_initEvents = /*#__PURE__*/ new WeakSet(), /**
     * init event inside modal,
     * should be called after a light delay (100ms) to ensure all modal content is rendered & ready
     */ $15d75720b00b40ae$var$_initModalEvents = /*#__PURE__*/ new WeakSet(), /**
     * Hijack tarteaucitron body class to animate the floating bar translation,
     * remove floating bar element, then remove body class
     */ $15d75720b00b40ae$var$_hideFloatingBar = /*#__PURE__*/ new WeakSet(), /**
     * customize (show modal)
     * triggered by customize button in floating bar
     */ $15d75720b00b40ae$var$_modalEventInit = /*#__PURE__*/ new WeakMap();
class $15d75720b00b40ae$var$TutoCitron {
    /**
     * accept all
     */ acceptAll() {
        tarteaucitron.userInterface.respondAll(true, "", true);
        (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_hideFloatingBar, $15d75720b00b40ae$var$hideFloatingBar).call(this);
    }
    /**
     * deny all
     */ denyAll() {
        tarteaucitron.userInterface.respondAll(false, "", true);
        (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_hideFloatingBar, $15d75720b00b40ae$var$hideFloatingBar).call(this);
    }
    customize() {
        (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_modalInstance).open();
        if (!(0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_modalEventInit)) setTimeout(()=>(0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_initModalEvents, $15d75720b00b40ae$var$initModalEvents).call(this), 100);
    }
    /**
     * switch all services to match global checked status
     * @param event
     */ switchAll(event) {
        for (const [i, _cb] of (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tutoModal).querySelectorAll('input[role="switch"]').entries())if (null !== _cb.id.match(/__service/)) _cb.checked = event.currentTarget.checked;
    }
    /**
     * Localization
     */ static localize(key) {
        if (key.includes("lang:")) key = key.replace("lang:", "");
        return tarteaucitron.lang[key];
    }
    /**
     * TAC OVERLOADS
     */ /**
     * Overload of TAC vanilla function
     * @param type
     */ jsSizing(type) {
    // void
    }
    constructor(){
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_buildCheckAllRow);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_buildModalContent);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_initModal);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_buildModal);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_createSwitchElement);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_convertButtonToSwitch);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_getHtmlSourceElement);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_initFloatingBar);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_convertToFloatingBar);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_initEvents);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_initModalEvents);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_hideFloatingBar);
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_floatingElement, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_btnAcceptAll, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_btnDenyAll, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_btnCustomize, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_tutoModal, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_tacRoot, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_tacModal, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_switchAll, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_switchAllId, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_acceptAllCallback, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_denyAllCallback, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_customizeAllCallback, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_switchAllCallback, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_checkedServicesCount, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_modalInstance, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_modalEventInit, {
            writable: true,
            value: void 0
        });
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_switchAllId, "switch-check_all");
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_modalEventInit, false);
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_tacRoot, document.getElementById("tarteaucitronRoot"));
        // [!] if no root found, script will stop here
        if (!(0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tacRoot)) {
            console.error("no root element found !");
            return;
        }
        (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_initFloatingBar, $15d75720b00b40ae$var$initFloatingBar).call(this);
        // [!] if no floating bar found, script will stop here
        if (!(0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_floatingElement)) {
            console.error("no floating element found !");
            return;
        }
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_checkedServicesCount, 0);
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_btnAcceptAll, (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_floatingElement).querySelector(".cookies-accept-all"));
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_btnDenyAll, (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_floatingElement).querySelector(".cookies-reject-all"));
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_btnCustomize, (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_floatingElement).querySelector(".cookies-customize"));
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_acceptAllCallback, this.acceptAll.bind(this));
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_denyAllCallback, this.denyAll.bind(this));
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_customizeAllCallback, this.customize.bind(this));
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_switchAllCallback, this.switchAll.bind(this));
        // HTML manipulations
        (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_buildModal, $15d75720b00b40ae$var$buildModal).call(this);
        (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_convertToFloatingBar, $15d75720b00b40ae$var$convertToFloatingBar).call(this);
        // prepare events (floating bar)
        (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_initEvents, $15d75720b00b40ae$var$initEvents).call(this);
    }
}
function $15d75720b00b40ae$var$buildCheckAllRow() {
    /**
         * @type {HTMLElement}
         * @private
         */ let _li = document.createElement("li");
    _li.id = "tarteaucitronServicesTitle_CheckAll";
    _li.classList.add("tarteaucitronLine", "tarteaucitronLineCheckAll");
    /**
         * @type {HTMLElement}
         * @private
         */ let _title = document.createElement("div");
    _title.id = "tarteaucitronServices_CheckAll";
    _title.classList.add("tarteaucitronTitle");
    _title.innerText = $15d75720b00b40ae$var$TutoCitron.localize("modalCheckAll");
    _li.appendChild(_title);
    /**
         * @type {HTMLElement}
         * @private
         */ let _ask = document.createElement("div");
    _ask.classList.add("tarteaucitronAsk");
    // all services are enabled, check all
    let _isChecked = (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_checkedServicesCount) === Object.keys(tarteaucitron.added).length;
    (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_switchAll, (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_createSwitchElement, $15d75720b00b40ae$var$createSwitchElement).call(this, (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_switchAllId), "check_all", "1", "tarteaucitronServices_CheckAll", _isChecked, false));
    _ask.appendChild((0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_switchAll));
    _li.appendChild(_ask);
    return _li;
}
function $15d75720b00b40ae$var$buildModalContent() {
    /**
         * Selectors to be removed from source content
         * @type {*[]}
         * @private
         */ let _selectorsToRemove = [
        ".clear",
        ".tarteaucitronReadmoreSeparator",
        ".tarteaucitronReadmoreInfo",
        ".tarteaucitronReadmoreOfficial"
    ];
    // div.tarteaucitronBorder => contains <ul> which contains <li> of services
    let _tacServicesWrapper = (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tacModal).querySelector(".tarteaucitronBorder");
    // remove unwanted selectors
    for (const [idx, _selector] of _selectorsToRemove.entries())_tacServicesWrapper.querySelectorAll(_selector).forEach((elem)=>elem.remove());
    // store all services
    let _tacServices = _tacServicesWrapper.querySelector("ul:first-child").querySelectorAll(":scope > li");
    // loop services to convert button set to switch input
    for (const [_servIdx, _service] of _tacServices.entries()){
        if (_service.id === "tarteaucitronServicesTitle_mandatory") _service.classList.add("tarteaucitronServicesTitle_mandatory");
        if (_service.id === "tarteaucitronServicesTitle_mandatory" || _service.style.display === "block") for (const [_btnElmIdx, _btnElm] of _service.querySelector(":scope > ul").querySelectorAll("button").entries())(0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_convertButtonToSwitch, $15d75720b00b40ae$var$convertButtonToSwitch).call(this, _btnElm);
    }
    // [!] HAS TO BE DONE AFTER SERVICES CONVERSION TO BUTTON
    // add check all row right after mandatory cookies
    _tacServicesWrapper.querySelector("#tarteaucitronServicesTitle_mandatory").after((0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_buildCheckAllRow, $15d75720b00b40ae$var$buildCheckAllRow).call(this));
    // remove unused <br>
    _tacServicesWrapper.querySelectorAll("br").forEach((elem)=>elem.remove());
    // swap <button> to <span> in .tarteaucitronTitle element
    _tacServicesWrapper.querySelectorAll("#tarteaucitronServicesTitle_mandatory > .tarteaucitronTitle > button, button.catToggleBtn").forEach((elem)=>{
        let _newElem = document.createElement("span");
        _newElem.innerText = elem.innerText.trim();
        elem.parentNode.replaceChild(_newElem, elem);
    });
    return _tacServicesWrapper.outerHTML;
}
function $15d75720b00b40ae$var$initModal() {
    (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_modalInstance, new $15d75720b00b40ae$var$TutoCitronModal((0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tutoModal)));
}
function $15d75720b00b40ae$var$buildModal() {
    const _modalHtml = (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_getHtmlSourceElement, $15d75720b00b40ae$var$getHtmlSourceElement).call(this, "modal");
    /**
         * add this point, if modal source is not found, no need to continue
         */ if ("" === _modalHtml) {
        console.error("modal source code not found !");
        return;
    }
    /**
         * add <dialog> source in tac root
         */ (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tacRoot).innerHTML += _modalHtml;
    (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_tutoModal, (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tacRoot).querySelector("#modal-tutocitron"));
    (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_tacModal, document.getElementById("tarteaucitron"));
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tacModal).querySelector("#tarteaucitronInfo").remove();
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tacModal).querySelectorAll(".tarteaucitronName")[0].remove();
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tacModal).querySelectorAll(".tarteaucitronAsk")[0].remove();
    // header
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tutoModal).querySelector(".heading").innerHTML = (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tacModal).querySelector("#dialogTitle").innerText;
    // content
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tutoModal).querySelector(".dialog-main-content").innerHTML = (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_buildModalContent, $15d75720b00b40ae$var$buildModalContent).call(this);
    // init modal => fire modal class
    (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_initModal, $15d75720b00b40ae$var$initModal).call(this);
}
function $15d75720b00b40ae$var$createSwitchElement(id, name, value, labelledby, isChecked, isDisabled) {
    /**
         * @type {HTMLElement}
         * @private
         */ let _switchWrapper = document.createElement("div");
    _switchWrapper.classList.add("gui-switch-wrapper");
    /**
         * @type {HTMLElement}
         * @private
         */ let _switchLabel = document.createElement("label");
    _switchWrapper.appendChild(_switchLabel);
    /**
         * @type {HTMLElement}
         * @private
         */ let _switchInner = document.createElement("div");
    _switchInner.classList.add("gui-switch");
    _switchLabel.appendChild(_switchInner);
    /**
         * @type {HTMLElement}
         * @private
         */ let _switchInput = document.createElement("input");
    _switchInput.classList.add("checkbox-switch");
    _switchInput.type = "checkbox";
    _switchInput.name = name;
    _switchInput.value = value;
    _switchInput.setAttribute("role", "switch");
    if (isDisabled === true) _switchInput.disabled = true;
    if (isChecked === true) _switchInput.setAttribute("checked", "checked");
    if (id) _switchInput.id = id;
    if (labelledby) _switchInput.setAttribute("aria-labelledby", labelledby);
    _switchInner.appendChild(_switchInput);
    return _switchWrapper;
}
function $15d75720b00b40ae$var$convertButtonToSwitch(_buttonElement) {
    if ("hidden" !== _buttonElement.style.visibility && "none" !== _buttonElement.style.display) {
        /**
             * hide button
             */ _buttonElement.style.display = "none";
        /**
             * only add switch once per button set
             */ if (null === _buttonElement.parentElement.querySelector(".gui-switch-wrapper")) {
            let isChecked = false, isDisabled = false;
            let _slug = "";
            if (!_buttonElement.closest("li").id) _slug = _buttonElement.closest("li").closest("ul").closest("li").id.replace("tarteaucitronServicesTitle_", "");
            else _slug = _buttonElement.closest("li").id.replace("Line", "");
            let _suffix = "";
            if ("mandatory" === _slug) {
                isChecked = true;
                isDisabled = true;
            } else _suffix = "__service" // append to find it while processing submit
            ;
            /**
                 * service name used to toggle switch
                 * @private
                 */ const _service = _buttonElement.id.replace("Allowed", "");
            if (tarteaucitron.state[_service]) {
                isChecked = true;
                (0, $3a63a2ea56dfd751$export$34564f03cc238d9f)(this, $15d75720b00b40ae$var$_checkedServicesCount).value++;
            }
            _buttonElement.parentElement.appendChild((0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_createSwitchElement, $15d75720b00b40ae$var$createSwitchElement).call(this, "switch-" + _slug + _suffix, "switch_" + _slug, "1", "", isChecked, isDisabled));
        }
    }
}
function $15d75720b00b40ae$var$getHtmlSourceElement(name) {
    for (const [idx, entry] of (0, $3c5a058a16dfb7f1$export$4c10b1e0a3c7fbb7).entries()){
        if (entry.name === name) return entry.html;
    }
    return "";
}
function $15d75720b00b40ae$var$initFloatingBar() {
    const _floatingBarHtml = (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_getHtmlSourceElement, $15d75720b00b40ae$var$getHtmlSourceElement).call(this, "floating-bar");
    if ("" === _floatingBarHtml) {
        console.error("floating bar source code not found !");
        return;
    }
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tacRoot).innerHTML += _floatingBarHtml;
    (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_floatingElement, $15d75720b00b40ae$var$getFromTemplateCitron("#floating-bar-template"));
}
function $15d75720b00b40ae$var$convertToFloatingBar() {
    /**
         * @type {HTMLElement}, outer element
         * @private
         */ const _tacBar = document.getElementById("tarteaucitronAlertBig");
    /**
         * @type {HTMLElement}
         * @private
         */ const _tacBtnCustomize = document.getElementById("tarteaucitronCloseAlert") // #tarteaucitronCloseAlert => personnaliser
    ;
    /**
         * @type {HTMLElement}
         * @private
         */ const _tacBtnDenyAll = document.getElementById("tarteaucitronAllDenied2") // #tarteaucitronAllDenied2 => tout refuser
    ;
    /**
         * @type {HTMLElement}
         * @private
         */ const _tacBtnAcceptContinue = document.getElementById("tarteaucitronPersonalize2") // #tarteaucitronPersonalize2 => accepter et continuer
    ;
    /**
         * udpate left content paragraph text
         */ (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_floatingElement).querySelector(".js-floating-bar-text").innerText = $15d75720b00b40ae$var$TutoCitron.localize((0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_floatingElement).querySelector(".js-floating-bar-text").innerText);
    /**
         * update btn accept all
         */ (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnAcceptAll).id = _tacBtnAcceptContinue.id;
    if (_tacBtnAcceptContinue.classList.length > 0) for (const _class of _tacBtnAcceptContinue.classList.entries())(0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnAcceptAll).classList.add(_class[1]);
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnAcceptAll).innerText = $15d75720b00b40ae$var$TutoCitron.localize((0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnAcceptAll).innerText);
    /**
         * update btn deny all
         */ (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnDenyAll).id = _tacBtnDenyAll.id;
    if (_tacBtnDenyAll.classList.length > 0) for (const _class of _tacBtnDenyAll.classList.entries())(0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnDenyAll).classList.add(_class[1]);
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnDenyAll).innerText = $15d75720b00b40ae$var$TutoCitron.localize((0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnDenyAll).innerText);
    /**
         * update btn customize
         */ (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnCustomize).id = _tacBtnCustomize.id;
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnCustomize).innerText = $15d75720b00b40ae$var$TutoCitron.localize((0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnCustomize).innerText);
    /**
         * required data attribute to enable tuto modal
         */ (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnCustomize).dataset.modalId = "modal-tutocitron";
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_floatingElement).style.display = _tacBar.style.display === "block" && _tacBar.style.opacity === "1" ? "block" : "none";
    /**
         * replace vanilla bar with up-to-date floating bar
         */ _tacBar.replaceWith((0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_floatingElement));
}
function $15d75720b00b40ae$var$initEvents() {
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnAcceptAll).addEventListener("click", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_acceptAllCallback));
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnDenyAll).addEventListener("click", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_denyAllCallback));
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_btnCustomize).addEventListener("click", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_customizeAllCallback));
}
function $15d75720b00b40ae$var$initModalEvents() {
    var _class_private_field_get_querySelector;
    (_class_private_field_get_querySelector = (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tutoModal).querySelector("#" + (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_switchAllId))) === null || _class_private_field_get_querySelector === void 0 ? void 0 : _class_private_field_get_querySelector.addEventListener("input", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_switchAllCallback));
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tutoModal).addEventListener("close", (event)=>{
        if (event.target.returnValue === "confirm") {
            // remove floating bar as it's not useful anymore
            (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_floatingElement).remove();
            // parse all services checkboxes
            for (const _service of Object.keys(tarteaucitron.added)){
                let _cb = (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_tutoModal).querySelector("input#switch-" + _service + "__service");
                if (_cb.checked) tarteaucitron.userInterface.respond(document.getElementById(_service + "Allowed"), true);
                else tarteaucitron.userInterface.respond(document.getElementById(_service + "Denied"), false);
            }
            // push confirmation
            $15d75720b00b40ae$var$pushConfirmation(false);
        }
        tarteaucitron.userInterface.closePanel();
    });
    (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_modalEventInit, true);
}
function $15d75720b00b40ae$var$hideFloatingBar() {
    document.querySelector("body").classList.add("tarteaucitron-modal-open");
    // remove floating bar as it's not useful anymore
    setTimeout(()=>{
        (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_floatingElement).remove();
        document.querySelector("body").classList.remove("tarteaucitron-modal-open");
    }, 500);
}
var /**
     * @type {?HTMLDialogElement}
     */ $15d75720b00b40ae$var$_dialogElement = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_closeButton = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_cancelButtons = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_confirmButtons = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_autofocusedButton = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_closeCallback = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_lightDismissCallback = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_handleEscapeKeyCallback = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_removeListenersCallback = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_resizeObserver = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_document = /*#__PURE__*/ new WeakMap(), $15d75720b00b40ae$var$_getButtons = /*#__PURE__*/ new WeakSet(), $15d75720b00b40ae$var$_addListeners = /*#__PURE__*/ new WeakSet(), /**
     * Change modal buttons tab order on screens < 640px
     * @param {ResizeObserverEntry[]} entries
     */ $15d75720b00b40ae$var$_watchResize = /*#__PURE__*/ new WeakSet(), /**
     * Remove listeners when closing the dialog
     * Avoid keeping event listeners in memory
     */ $15d75720b00b40ae$var$_removeListeners = /*#__PURE__*/ new WeakSet(), /**
     * @param {'enter' | 'exit'} direction
     */ $15d75720b00b40ae$var$_translateModal = /*#__PURE__*/ new WeakSet(), /**
     * @param {KeyboardEvent} event
     */ $15d75720b00b40ae$var$_handleEscapeKey = /*#__PURE__*/ new WeakSet();
// ---------- Modal ----------
class $15d75720b00b40ae$var$TutoCitronModal {
    init() {
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_closeCallback, this.close.bind(this, "closed"));
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_lightDismissCallback, (0, $685ea8009867723a$export$68238ee8e0a3fa8c)($15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$lightDismiss).bind(this));
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_handleEscapeKeyCallback, (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_handleEscapeKey, $15d75720b00b40ae$var$handleEscapeKey).bind(this));
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_removeListenersCallback, (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_removeListeners, $15d75720b00b40ae$var$removeListeners).bind(this));
        (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_getButtons, $15d75720b00b40ae$var$getButtons).call(this);
    }
    open() {
        var _document_activeElement;
        (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_addListeners, $15d75720b00b40ae$var$addListeners).call(this);
        tarteaucitron.userInterface.openPanel();
        (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).showModal();
        (_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.setAttribute("autofocus", "");
        (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_translateModal, $15d75720b00b40ae$var$translateModal).call(this, "enter");
    }
    /**
     * @param {string?} message - Close the modal and dispatch message
     */ close(message = "") {
        tarteaucitron.userInterface.closePanel();
        (0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_translateModal, $15d75720b00b40ae$var$translateModal).call(this, "exit");
        setTimeout(()=>{
            (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).close(message);
        }, 300);
    }
    /**
     * @param {HTMLDialogElement|string} htmlContent
     */ setHTML(htmlContent) {
        (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).innerHTML = htmlContent instanceof HTMLElement ? htmlContent.innerHTML : htmlContent;
        this.init();
    }
    /**
     * @param {HTMLDialogElement?} dialogElement
     */ constructor(dialogElement){
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_getButtons);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_addListeners);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_watchResize);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_removeListeners);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_translateModal);
        (0, $86ed3387c72e1975$export$1002c20f28174dbf)(this, $15d75720b00b40ae$var$_handleEscapeKey);
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_dialogElement, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_closeButton, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_cancelButtons, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_confirmButtons, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_autofocusedButton, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_closeCallback, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_lightDismissCallback, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_handleEscapeKeyCallback, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_removeListenersCallback, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_resizeObserver, {
            writable: true,
            value: void 0
        });
        (0, $536e2c71784255ec$export$e235798705076415)(this, $15d75720b00b40ae$var$_document, {
            writable: true,
            value: void 0
        });
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_cancelButtons, []);
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_confirmButtons, []);
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_dialogElement, dialogElement);
        (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_document, document.documentElement);
        this.init();
    }
}
var $15d75720b00b40ae$var$_translateY0 = {
    writable: true,
    value: "translateY(0)"
};
var $15d75720b00b40ae$var$_translateUp = {
    writable: true,
    value: "translateY(-3.125rem)"
};
var $15d75720b00b40ae$var$_opacity100 = {
    writable: true,
    value: "1"
};
var $15d75720b00b40ae$var$_opacity0 = {
    writable: true,
    value: "0"
};
function $15d75720b00b40ae$var$getButtons() {
    (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_closeButton, (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).querySelector(".js-modal-close"));
    (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_cancelButtons, [
        ...(0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).querySelectorAll('[type="reset"]')
    ]);
    (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_confirmButtons, [
        ...(0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).querySelectorAll('[type="submit"]')
    ]);
    [
        ...(0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_cancelButtons),
        ...(0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_confirmButtons)
    ].forEach((button)=>{
        if (button.hasAttribute("autofocus")) (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_autofocusedButton, button);
        button.innerHTML = $15d75720b00b40ae$var$TutoCitron.localize(button.innerHTML);
    });
}
function $15d75720b00b40ae$var$addListeners() {
    var _class_private_field_get1;
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).addEventListener("keydown", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_handleEscapeKeyCallback));
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).addEventListener("click", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_lightDismissCallback));
    [
        (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_closeButton),
        ...(0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_cancelButtons),
        ...(0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_confirmButtons)
    ].forEach((button)=>{
        button === null || button === void 0 ? void 0 : button.addEventListener("blur", (0, $685ea8009867723a$export$68238ee8e0a3fa8c)($15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$removeAutofocus));
    });
    (_class_private_field_get1 = (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_closeButton)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.addEventListener("click", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_closeCallback));
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_cancelButtons).forEach((cancelButton)=>{
        cancelButton.addEventListener("click", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_closeCallback));
    });
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).addEventListener("close", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_removeListenersCallback));
    (0, $86870fdf2eb51a70$export$268446c9779b3a21)(this, $15d75720b00b40ae$var$_resizeObserver, new ResizeObserver((0, $423958fa057c9ccd$export$ccedaf978f62b9dd)(this, $15d75720b00b40ae$var$_watchResize, $15d75720b00b40ae$var$watchResize).bind(this)));
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_resizeObserver).observe((0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_document));
}
function $15d75720b00b40ae$var$watchResize(entries) {
    entries.forEach((entry)=>{
        const primaryButton = (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).querySelector(".btn-primary");
        const secondaryButton = (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).querySelector(".btn-secondary");
        if (entry.target.clientWidth < 640) {
            var _class_private_field_get1;
            primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.setAttribute("tabindex", "2");
            secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.setAttribute("tabindex", "3");
            (_class_private_field_get1 = (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_closeButton)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.setAttribute("tabindex", "1");
        } else {
            var _class_private_field_get2;
            primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.removeAttribute("tabindex");
            secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.removeAttribute("tabindex");
            (_class_private_field_get2 = (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_closeButton)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.removeAttribute("tabindex");
        }
    });
}
function $15d75720b00b40ae$var$removeListeners() {
    var _class_private_field_get1, _class_private_field_get2;
    [
        (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_closeButton),
        ...(0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_cancelButtons),
        ...(0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_confirmButtons)
    ].forEach((button)=>{
        button === null || button === void 0 ? void 0 : button.removeEventListener("blur", (0, $685ea8009867723a$export$68238ee8e0a3fa8c)($15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$removeAutofocus));
    });
    (_class_private_field_get1 = (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_closeButton)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.removeEventListener("click", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_closeCallback));
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_cancelButtons).forEach((cancelButton)=>{
        cancelButton.removeEventListener("click", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_closeCallback));
    });
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).removeEventListener("click", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_lightDismissCallback));
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).removeEventListener("keydown", (0, $685ea8009867723a$export$68238ee8e0a3fa8c)($15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$preventEscapeKey));
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).removeEventListener("keydown", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_handleEscapeKeyCallback));
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).removeEventListener("close", (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_removeListenersCallback));
    (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_resizeObserver).disconnect();
    (_class_private_field_get2 = (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_autofocusedButton)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.setAttribute("autofocus", "");
}
function $15d75720b00b40ae$var$translateModal(direction) {
    if ("enter" === direction) {
        (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).style.transform = (0, $7dddac0e5986aad9$export$5160b3efe6f07044)($15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$_translateY0);
        (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).style.opacity = (0, $7dddac0e5986aad9$export$5160b3efe6f07044)($15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$_opacity100);
    }
    if ("exit" === direction) {
        (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).style.transform = (0, $7dddac0e5986aad9$export$5160b3efe6f07044)($15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$_translateUp);
        (0, $1aea1dee9c0bc6dd$export$5a67b255b80ee4f2)(this, $15d75720b00b40ae$var$_dialogElement).style.opacity = (0, $7dddac0e5986aad9$export$5160b3efe6f07044)($15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$TutoCitronModal, $15d75720b00b40ae$var$_opacity0);
    }
}
/**
     * @param {HTMLElement} element
     */ function $15d75720b00b40ae$var$lightDismiss({ target: element  }) {
    if ("DIALOG" === element.nodeName) this.close("closed");
}
/**
     * @param {HTMLElement} button
     */ function $15d75720b00b40ae$var$removeAutofocus({ target: button  }) {
    button.removeAttribute("autofocus");
}
/**
     * @param {KeyboardEvent} event
     */ function $15d75720b00b40ae$var$preventEscapeKey(event) {
    if ("Escape" === event.key) event.preventDefault();
}
function $15d75720b00b40ae$var$handleEscapeKey(event) {
    if ("Escape" === event.key) {
        event.preventDefault();
        this.close("closed");
    }
}
// ---------
const $15d75720b00b40ae$var$showCookiesManagementPanel = ()=>{
    $15d75720b00b40ae$var$TutoCitronInst.customize();
};
window.showCookiesManagementPanel = $15d75720b00b40ae$var$showCookiesManagementPanel;
// GTM confirmation
let $15d75720b00b40ae$var$GTMConfirmation = function(cookie) {
    if (cookie != null) dataLayer.push({
        "event": "tutocitronServicesUpdated",
        "tutocitronActiveServices": cookie
    });
    else dataLayer.push({
        "event": "tutocitronServicesUpdated"
    });
    return true;
};
window.GTMConfirmation = $15d75720b00b40ae$var$GTMConfirmation;
// ---------
// Async Push of choices
let $15d75720b00b40ae$var$pushConfirmation = function(_reloadThePage) {
    $15d75720b00b40ae$var$GTMConfirmation(tarteaucitron.cookie.read(tarteaucitron.parameters.cookieName));
    let xhttp = new XMLHttpRequest();
    xhttp.open("POST", $15d75720b00b40ae$var$ajax_prefixCitron + "consent/save", true);
    xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhttp.onreadystatechange = function() {
        if (xhttp.readyState === 4 && xhttp.status === 200) {
            if (_reloadThePage === true) window.location.reload();
        }
    };
    xhttp.send("consent_choice=" + tarteaucitron.cookie.read(tarteaucitron.parameters.cookieName));
    if (typeof dataLayer !== "undefined" && typeof mktcv !== "undefined") mktcv(dataLayer[0]);
} // ---------
;

})();
//# sourceMappingURL=tutocitron.js.map
